export default __webpack_public_path__ + "static/media/phone-contact.2de91f90.svg";